import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-header-qrcode',
  templateUrl: './header-qrcode.component.html',
  styleUrls: ['./header-qrcode.component.scss']
})
export class HeaderQrcodeComponent implements OnInit {

  @Input() qrcodeUrl;

  constructor() { }

  ngOnInit() {
  }

}
